import { http } from 'vue'

export default {
  // edit client at the API server
  putCompanySettings (context, params = {}) {
    return http.put('company_settings/' + params.companyId, params.data)
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/company_settings/actions.js